<!-- Container-fluid starts -->
<div class="container-fluid" #content id="modal-basic-title">
	<div class="row">
		<div class="col-sm-12">
			<div class="">
				<h2 class="title-page">Commandes</h2>
				<!-- Sort and search bar -->
				<div class="filter-search">
					<!-- Sort bar -->
					<!-- <ngbDropdown ngbDropdown class="d-inline-block filter-block">
						<button (click)="toggleFilter()" type="button" class="btn btn-sort filter-bar form-control">Trier par</button>
					</ngbDropdown> -->

					<div class="search-block order-search-block">
						<!-- search bar -->
						<!-- <div *ngIf="searchOption !== 'shop'"> -->
						<div>
							<input type='text' class="form-control search-bar" placeholder='Recherche...'
								[(ngModel)]="searchField" (keydown.enter)="onSearchChange(searchField)">
							<div class="btn-reset-search" (click)="resetSearch()">
								<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" class="feather feather-delete" _ngcontent-bnt-c218="">
									<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path>
									<line x1="18" y1="9" x2="12" y2="15"></line>
									<line x1="12" y1="9" x2="18" y2="15"></line>
								</svg>
							</div>
						</div>
						<!-- <div *ngIf="searchOption === 'shop'" class="search-filter-shop">
							<mat-form-field appearance="fill">
								<mat-label>Choisir une option</mat-label>
								<mat-select [(value)]="idShopSearch" (selectionChange)="onSearchIdShop()">
									<mat-option *ngFor="let shop of listShops" value={{shop.id}}>{{shop.name}}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div> -->
						<!-- select field -->
						<div class="search-filter-block">
							<mat-form-field appearance="fill">
								<mat-label>Choisir une option</mat-label>
								<mat-select [(value)]="searchOption" (selectionChange)="resetSearchField()">
									<mat-option value="client">Client</mat-option>
									<mat-option value="shop">Adhérent</mat-option>
									<mat-option value="order">Commande</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<!-- Bouton valider -->
						<div class="btn-submit">
							<button type="button" class="btn btn-submit btn-success btn-submit-search"
								(click)="onSearchChange(searchField)">Valider</button>
						</div>
						<!-- Order status checkboxes -->
						<div class="etat-demande filter-item">
							<label class="title">Etat de commande:</label>
							<mat-radio-group aria-label="Etat de commande" (change)="onChangeFilter($event)">
								<mat-radio-button checked="true" color="primary" value="all-order">Tous
								</mat-radio-button>
								<mat-radio-button color="primary" value="pending-payment">À payer</mat-radio-button>
								<mat-radio-button color="primary" value="pending-order">En attente</mat-radio-button>
								<mat-radio-button color="primary" value="processing-order">En préparation</mat-radio-button>
                                <mat-radio-button color="primary" value="sent-order">Expédié</mat-radio-button>
								<mat-radio-button color="primary" value="completed-order">Livré</mat-radio-button>
								<mat-radio-button color="primary" value="cancelled-order">Annulé</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>

					<div class="network-filter" *ngIf="onTwoNetworks">
						<label class="network-title">Réseaux:</label>
						<mat-radio-group aria-label="RéseauxRéseaux" (change)="getOrdersByNetwork($event)">
							<mat-radio-button checked="true" color="primary" value="MDM">MDM</mat-radio-button>
							<mat-radio-button color="primary" value="SM">SM</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
				<!-- Sort dropdown -->
				<!-- <div id="table-filter" style="display: none">
					<div class="table-filter"> -->
				<!-- Sort by date -->
				<!-- <div class="check-date filter-item">
							<label class="title">Date d'achat:</label>
							<div>
								<mat-radio-group [(ngModel)]="orderDate" (change)="onChangeFilter($event)">
									<mat-radio-button color="primary" value="newest-date">Du plus récent au plus ancien</mat-radio-button>
									<mat-radio-button color="primary" value="oldest-date" (change)="onChangeFilter($event)">Du plus ancien au plus récent</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>  -->
				<!-- Sort by status of orders -->
				<!-- <div class="etat-demande filter-item">
							<label class="title">Etat de commande:</label>
							<mat-radio-group aria-label="Etat de commande" (change)="onChangeFilter($event)">
								<mat-radio-button checked="true" color="primary" value="all-order">Tous</mat-radio-button>
								<mat-radio-button color="primary" value="pending-order">En attente</mat-radio-button>
								<mat-radio-button color="primary" value="processing-order">En cours</mat-radio-button>
								<mat-radio-button color="primary" value="completed-order">Livré</mat-radio-button>
								<mat-radio-button color="primary" value="cancelled-order">Annulé</mat-radio-button>
							</mat-radio-group>
						</div> 
					</div>
				</div> -->

				<div class="">
					<!-- Table -->
					<ngx-datatable [rows]="orders" class="material striped" [columnMode]="ColumnMode.force" [headerHeight]="50"
						[footerHeight]="50" [scrollbarH]="true" [responsive]="true" [rowHeight]="'auto'" [columns]="columns" [messages]="empty_msgFr">
						<!-- Columns -->
						<ngx-datatable-column *ngFor="let column of columns; let i = index" name="{{ column.name }}" prop="{{ column.prop }}">
							<!-- Rows -->
							<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>

								<!-- Date -->
								<spans *ngIf="column.prop === 'date'">
									<span>{{value | date:'medium'}}</span>
								</spans>

								<!-- Status -->
								<span *ngIf="column.prop === 'status'">
									<div class="status-order" [ngClass]="row.status">
										{{statusConfigDataTableOrder[row.status][column.prop]}}
									</div>
								</span>

								<!-- Pose -->
								<spans *ngIf="column.prop === 'pose'">
									<span *ngIf="value"><i class="fa fa-exclamation-triangle" style="color: var(--btn_orange)"></i></span>
								</spans>

								<!-- Cotes -->
								<spans *ngIf="column.prop === 'cote'">
									<span *ngIf="value"><i class="fa fa-exclamation-triangle" style="color: var(--btn_orange)"></i></span>
								</spans>

								<!-- BTN column Étape de la commande -->
								<span *ngIf="column.prop === 'btn_payment'">

								

									<!-- btn disabled if deleted option -->
									<button *ngIf="(row.status === 'refunded' || row.status === 'cancelled') && role === 'Provider'"
										class="btn_bo btn_payment btn_disabled {{ [row.status] }}_{{ [column.prop] }}">
										Annulé
									</button>


									<!-- btn modifer -->
									<button *ngIf="(row.status === 'processing' || row.status === 'shipped'  && role === 'Shop') || (!row.validated && row.status === 'to-process' || !row.validated && row.status === 'shipped')"
										(click)="openOrderManagement(row)"
										class="btn_bo btn_payment {{ [row.status] }}_{{ [column.prop] }}">
										<i class="fa fa-edit fa-lg"
										*ngIf="row.status === 'pending' || row.status === 'processing' || row.status === 'on-hold' || row.status === 'shipped' || row.status === 'to-process'"></i>
										{{ statusConfigDataTableOrder[row.status][column.prop] }}
									</button>

									<!-- btn deleted -->
									<button  (click)="openOrderdelete(row)" *ngIf="(row.status === 'refunded' || row.status === 'cancelled') && role === 'Shop'" class="btn_bo btn_deleted ">
										<i class="fa fa-times-circle fa-lg"></i>
										{{ statusConfigDataTableOrder[row.status][column.prop] }}
									</button>
								</span>

								<!-- BTN column estimation de livraison -->
								<span *ngIf="column.prop === 'btn_estimation'">
									<button *ngIf="row.status !== 'processing' && row.status !== 'shipped'" 
										class="btn_bo btn_estimation btn_disabled {{ [row.status] }}_{{ [column.prop] }}">
										<i *ngIf="row.status === 'pending' || row.status === 'processing' || row.status === 'on-hold' || row.status === 'to-process'" class="fa fa-edit fa-lg"></i>
										{{ statusConfigDataTableOrder[row.status][column.prop] }}
									</button>
									<button
										*ngIf="row.status === 'processing' || row.status === 'shipped'"
										class="btn_bo btn_estimation {{ [row.status] }}_{{ [column.prop] }}"
										(click)="openDeliveryEstimate(row)">
										<i class="fa fa-edit fa-lg"
											*ngIf=" row.status === 'pending' || row.status === 'processing' || row.status === 'shipped' || row.status === 'on-hold'"></i>
										{{ statusConfigDataTableOrder[row.status][column.prop] }}
									</button>
								</span>
								<span *ngIf="column.prop === 'comment'">
                                    {{row.cancel.type == "order_cancelled" ? 'Web-To-Store' : order?.comment}}
								</span>
								<!-- BTN voir -->
								<span *ngIf="column.prop === 'btn_show'">
									<button class="btn_bo btn_show" (click)="showOrderDetails(row)">
										<i class="fa fa-eye fa-lg"></i>
										{{ statusConfigDataTableOrder[row.status][column.prop] }}
									</button>
								</span>
								<span *ngIf="column.prop !== 'status' && column.prop !== 'date' && column.prop !== 'pose' && column.prop !== 'cote'">{{ value }}</span>
							</ng-template>
							<!-- Column Status -> explication popup -->
							<!-- <ng-template ngx-datatable-header-template let-column="column">
								<span *ngIf="column.name === 'Statut'">{{ column.name }} <i
										*ngIf="column.name === 'Statut'" class='fa fa-question-circle hint'
										(click)="openStatusModal(hint)"></i></span>
								<span *ngIf="column.name !== 'Statut'">{{ column.name }}</span>
							</ng-template> -->
						</ngx-datatable-column>
					</ngx-datatable>
				</div>
				<!-- Pagination bar -->
				<div class="pagination-top">
					<ngb-pagination class="d-flex justify-content-center" [pageSize]="pageSize"
						[collectionSize]="collectionSize" [(page)]="currentPage" [maxSize]="5" [rotate]="true"
						[ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
				</div>
			</div>
		</div>
	</div>
</div>